module.exports = __webpack_public_path__ + "static/banner-printers-bbcc26d91f87aa4dfcebc34aa18844e0.png";